module.exports = __webpack_public_path__ + "static/assets/86a3405446903938c51fd587e243fe33.svg";